import type { Column } from '@talos/kyoko';
import type { ColDef } from 'ag-grid-community';
import { PriceGridSymbolMenu } from '../hooks/actions/symbolMenu/PriceGridSymbolMenu';
import type { PriceGridEntity } from '../PriceGridEntity';
import {
  getPriceGridMarketDataColumnId,
  getSymbolFromRow,
  PRICE_GRID_MARKET_DATA_MENU_COLUMN_SUFFIX,
  PRICE_GRID_SYMBOL_MENU_COLUMN_WIDTH,
  type PriceGridMarketDataColumnRow,
  type PriceGridMarketDataRendererParams,
} from './priceGridMarketDataColumnUtils';
import { getPriceGridRowActionColumn } from './priceGridRowActionColumn';
import type { PriceGridSecurityMarketDataColumnParams } from './types';

export function getPriceGridSymbolMenuColumn(
  column: Column<PriceGridSecurityMarketDataColumnParams, PriceGridMarketDataColumnRow>
): Column<ColDef<PriceGridEntity, PriceGridEntity>, PriceGridMarketDataColumnRow> {
  return getPriceGridRowActionColumn<PriceGridEntity, PriceGridMarketDataColumnRow>({
    colId: getPriceGridMarketDataColumnId(column, PRICE_GRID_MARKET_DATA_MENU_COLUMN_SUFFIX),
    field: column.field,
    width: PRICE_GRID_SYMBOL_MENU_COLUMN_WIDTH,
    cellRenderer: (params: PriceGridMarketDataRendererParams) => {
      const row = params.value;
      const symbol = row ? getSymbolFromRow(column, row) : undefined;
      if (!row || !symbol) {
        return null;
      }
      const colDef = { ...params.colDef, dynamics: column.dynamics };

      return <PriceGridSymbolMenu params={{ ...params, colDef, data: row }} />;
    },
  });
}
